import { controlsContainerStyles } from "@insite/content-library/Widgets/ProductList/ProductListControlsContainer";

controlsContainerStyles.countGridItem = {
    width: [12, 12, 4, 5, 5],
};
controlsContainerStyles.sortGridItem = {
    width: [12, 12, 4, 4, 4],
};
